var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 14.1667C5.08515 14.1667 4.7672 14.2984 4.53278 14.5328C4.29836 14.7672 4.16667 15.0852 4.16667 15.4167C4.16667 15.8769 3.79357 16.25 3.33333 16.25C2.8731 16.25 2.5 15.8769 2.5 15.4167C2.5 14.6431 2.80729 13.9013 3.35427 13.3543C3.90125 12.8073 4.64312 12.5 5.41667 12.5H15.8333C16.2936 12.5 16.6667 12.8731 16.6667 13.3333C16.6667 13.7936 16.2936 14.1667 15.8333 14.1667H5.41667Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 3.33334C5.08515 3.33334 4.7672 3.46503 4.53278 3.69946C4.29836 3.93388 4.16667 4.25182 4.16667 4.58334V15.4167C4.16667 15.7482 4.29836 16.0661 4.53278 16.3006C4.7672 16.535 5.08515 16.6667 5.41667 16.6667H15V3.33334H5.41667ZM3.35427 2.52094C3.90125 1.97396 4.64312 1.66667 5.41667 1.66667H15.8333C16.2936 1.66667 16.6667 2.03977 16.6667 2.50001V17.5C16.6667 17.9602 16.2936 18.3333 15.8333 18.3333H5.41667C4.64312 18.3333 3.90125 18.026 3.35427 17.4791C2.80729 16.9321 2.5 16.1902 2.5 15.4167V4.58334C2.5 3.80979 2.80729 3.06792 3.35427 2.52094Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbook);
export default __webpack_public_path__ + "static/media/cashbook.3a6259f80a8c4f365cd4c332f29fdbd8.svg";
export { ForwardRef as ReactComponent };